import { captureException, withScope } from "@sentry/browser";

export function logError(error, errorInfo) {
  withScope(scope => {
    scope.setExtras(errorInfo);
    captureException(error);
  });
}
